import axios from "axios";
import { getToken } from "../Common";

export const url = "etdportal/";
//===================== docume verificationn api =====================
export const documentVerification = (payload) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Basic ${btoa("WebUser:Shares@202$")}`,
  };
  return axios
    .post(url + "document_search", payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//===================== photo upload api =====================
export const photoUpload = (payload, apiUrl) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios
    .post(url + apiUrl, payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//================================ nida verification api ============================
export const nidaVerification = (payload) => {
  return axios
    .post(url, payload)
    .then((response) => response?.data)
    .catch((error) => {
      // console.error("Error fetching data:", error);
      throw error;
    });
};

//====================== Email verification ==========================
export const verificationAPI = (payload, urlAPI) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Basic ${btoa("WebUser:Shares@202$")}`,
  };
  return axios
    .post(url + urlAPI, payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//==============================  lookups =========================
export const etdLookups = (payload) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Basic ${btoa("WebUser:Shares@202$")}`,
  };
  return axios
    .post(url + "/lookup", payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//==============================  Application management =========================
export const applicationManagement = (payload, apiUrl) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios
    .post(url + apiUrl, payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//==============================  Twahir App. management =========================
export const applicationManagementTwahir = (payload, apiUrl) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return axios
    .post(url + apiUrl, payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//==============================  Masilingi App. management =========================
export const applicationManagementMasilingi = (payload, apiUrl) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios
    .post(url + apiUrl, payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

//============================== Login api  =========================
export const login = (payload) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Basic ${btoa("WebUser:Shares@202$")}`,
  };

  return axios
    .post(url + "app-login", payload, { headers })
    .then((response) => response?.data)
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};
